import { logAppError } from 'Helpers/logger'
import { type Getter, type Setter } from 'jotai'
import {
  errorUpdater,
  loaderUpdater,
  pageState,
  statusUpdater,
} from 'State/page'
import {
  getAllGroups,
  getDynamicFields,
  getGeoCountries,
  getAllTags,
} from '../services/specServices'
import {
  allGroupsAtom,
  countriesAtom,
  countriesLoadingAtom,
  dynamicFieldsAtom,
  regionsLoadingAtom,
  tagsAtom,
} from '../state/specState'

export const getAllGroupsCallback = async (
  get: Getter,
  set: Setter,
): Promise<void> => {
  if (get(allGroupsAtom).length === 0) {
    set(pageState, loaderUpdater(true))
    try {
      const pagedGroups = await getAllGroups()
      set(allGroupsAtom, pagedGroups.Items)
      set(pageState, statusUpdater('ready'))
    } catch (e) {
      console.error('### error', e)
      logAppError({
        Component: 'CombinedFilterFormPage',
        Method: 'getAllGroups',
        appError: e instanceof Error ? e : undefined,
      })
      set(pageState, errorUpdater)
    }
    set(pageState, loaderUpdater(false))
  }
}

export const getDynamicFieldsCallback = async (
  get: Getter,
  set: Setter,
): Promise<void> => {
  if (get(dynamicFieldsAtom).length === 0) {
    set(pageState, loaderUpdater(true))
    try {
      const dynamicFields = await getDynamicFields()
      set(dynamicFieldsAtom, dynamicFields)
      set(pageState, statusUpdater('ready'))
    } catch (e) {
      console.error('### error', e)
      logAppError({
        Component: 'CombinedFilterFormPage',
        Method: 'getDynamicFieldsCallback',
        appError: e instanceof Error ? e : undefined,
      })
      set(pageState, errorUpdater)
    }
    set(pageState, loaderUpdater(false))
  }
}

export const getAllTagsCallback = async (
  get: Getter,
  set: Setter,
): Promise<void> => {
  if (get(tagsAtom).length === 0) {
    set(pageState, loaderUpdater(true))
    try {
      const pagedTags = await getAllTags()
      set(tagsAtom, pagedTags.Items)
      set(pageState, statusUpdater('ready'))
    } catch (e) {
      console.error('### error', e)
      logAppError({
        Component: 'CombinedFilterFormPage',
        Method: 'getAllTags',
        appError: e instanceof Error ? e : undefined,
      })
      set(pageState, errorUpdater)
    }
    set(pageState, loaderUpdater(false))
  }
}

export const getGeoCountriesCallback = async (
  get: Getter,
  set: Setter,
): Promise<void> => {
  if (get(countriesAtom).length === 0) {
    set(countriesLoadingAtom, true)
    try {
      const countries = await getGeoCountries()

      set(countriesAtom, countries)
    } catch (e) {
      console.error('### error', e)
      logAppError({
        Component: 'CombinedFilterFormPage',
        Method: 'getGeoCountriesCallback',
        appError: e instanceof Error ? e : undefined,
      })
      set(pageState, errorUpdater)
    }
    set(countriesLoadingAtom, false)
  }
}

export const resetSpecState = (set: Setter): void => {
  set(allGroupsAtom, [])
  set(dynamicFieldsAtom, [])
  set(tagsAtom, [])
  set(countriesAtom, [])
  set(countriesLoadingAtom, false)
  set(regionsLoadingAtom, false)
}
